import { io } from "socket.io-client";

const url = process.env.REACT_APP_BASE_URL?.replace("/v1", "");

export const socket = io(url || "http://localhost:3000", {
    transports: ["websocket", "polling"],
    reconnection: true,
});
